import { InjectionToken, Type } from '@angular/core';
import { DrawerRef } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-manager.service';
import { ShoppingCartItem } from './shopping-cart.types';

export interface ShoppingCartDrawerData {
  items: ShoppingCartItem<any>[];
  // Add any other data you want to pass to the drawer
}

export interface ShoppingCartDrawerWrapper {
  /**
   * Opens the shopping cart drawer with the provided items
   */
  openDrawer(data: ShoppingCartDrawerData): DrawerRef<any> | void;

  /**
   * Closes the shopping cart drawer if it's open
   */
  closeDrawer?(): void;
}

/**
 * Injection token for the shopping cart drawer wrapper
 * Each application can provide their own implementation
 */
export const SHOPPING_CART_DRAWER_WRAPPER = new InjectionToken<ShoppingCartDrawerWrapper>(
  'SHOPPING_CART_DRAWER_WRAPPER'
);

/**
 * Alternative approach using component type injection
 */
export const SHOPPING_CART_DRAWER_COMPONENT = new InjectionToken<Type<any>>(
  'SHOPPING_CART_DRAWER_COMPONENT'
);
